var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGreenBackgroundSolidWhiteTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 14A7 7 0 107 0a7 7 0 000 14z",
    fill: "#0EA546"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.455 4.764a.906.906 0 011.28 0 .903.903 0 010 1.279L7.037 9.735a.906.906 0 01-1.28 0L3.764 7.747a.903.903 0 010-1.278.906.906 0 011.28 0l1.352 1.349 3.058-3.054z",
    fill: "#fff"
  })));
}

export default SvgGreenBackgroundSolidWhiteTick;